import { useTranslate } from '@festina-life/ui/hooks'

import { TransferButton } from '../../components/transferButton/TransferButton'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useRegisteredTenant } from '../../system/useRegisteredTenant'
import { detectTenantTransferConflict } from '../../uiModels/transfer/detectTenantTransferConflict'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { useOperationsContext } from '../../workspace/operationsContext'

/** Transfers the registration of the tenant in scope to an ancestor block. */
export const TenantTransferButton = () => {
  const translate = useTranslate()
  const currentTenantRegistrationId = useRegisteredTenant() ?? ''
  const { block: currentViewBlock } = useNavigationParams()
  const { applicationRegisteredTenants } = useApplicationViewOperationsContext()
  const { registeredTenantCreateOperations } = useOperationsContext()

  const registeredTenantOperation = applicationRegisteredTenants.find(
    (operation) =>
      operation.internalOperation.registeredTenant?.tenantId ===
      currentTenantRegistrationId,
  )

  const transferableOperations =
    registeredTenantOperation?.block === currentViewBlock &&
    !registeredTenantOperation.isDraft
      ? [registeredTenantOperation]
      : []

  return (
    <TransferButton
      item={{
        itemId: currentTenantRegistrationId,
        type: 'tenant',
        operationName: currentTenantRegistrationId,
        versionCount: transferableOperations.length,
        isTransferable: !!transferableOperations.length,
      }}
      transfer={{
        label: translate('tenantViewer.topBar.actions.transfer'),
        description: translate(
          'transfer.confirmationModal.tenant.description',
          {
            sourceBlock: currentViewBlock,
          },
        ),
        getConflictWarning: (destinationBlock) =>
          detectTenantTransferConflict({
            registeredTenantCreateOperations,
            tenantId: currentTenantRegistrationId,
            destinationBlock,
          })
            ? translate('transfer.confirmationModal.conflict.warning')
            : undefined,
        onConfirm: ({ transfer }) =>
          transfer({
            shouldInvalidateCacheAfterTransfer: true,
            operationName: currentTenantRegistrationId,
            operations: transferableOperations,
          }),
      }}
    />
  )
}
